import { render, staticRenderFns } from "./GeneralCompanyInfo.vue?vue&type=template&id=909e8ffc&scoped=true&"
import script from "./GeneralCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./GeneralCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./GeneralCompanyInfo.vue?vue&type=style&index=0&id=909e8ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909e8ffc",
  null
  
)

export default component.exports